import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'angie-link-cell',
	standalone: true,
	templateUrl: 'link-cell.component.html',
	styleUrls: ['./link-cell.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkCellComponent {
	/** Content of the cell */
	@Input() text: string;
	/** Link destination */
	@Input() href: string;
	/** If link is external, it opens in another tab  */
	@Input() isExternal: boolean;
	/** Fallback content in text is empty */
	@Input() fallback: string = '-';
}
